import React, { FC } from "react";
import { defineMessages, useIntl } from "react-intl";

import acknowledgements from "@etc/acknowledgements.json";

import "./billingFooter.scss";

const messages = defineMessages({
  billingFooterCookiesInfo: {
    id: "billingFooterCookiesInfo",
    defaultMessage:
      "This site uses cookies to enhance your experience. Any cookies preferences selected on Natera.com will not apply.",
  },
  postbillGuestLoginAcknowledgements: {
    id: "postbillGuestLoginAcknowledgements",
    defaultMessage:
      "By continuing you accept our {termsOfUse}, {privacyPolicy} and {privacyPractices}",
  },
  postbillGuestLoginTermsOfUse: {
    id: "postbillGuestLoginTermsOfUse",
    defaultMessage: "Terms of Use",
  },
  postbillGuestLoginPrivacyPolicy: {
    id: "postbillGuestLoginPrivacyPolicy",
    defaultMessage: "Privacy Policy",
  },
  postbillGuestLoginPrivacyPractices: {
    id: "postbillGuestLoginPrivacyPractices",
    defaultMessage: "Notice of Privacy Practices",
  },
});

const BillingFooter: FC = () => {
  const intl = useIntl();

  return (
    <div className="billing-footer">
      <p className="billing-footer__cookies">
        {intl.formatMessage(messages.billingFooterCookiesInfo)}
      </p>
      <p className="billing-footer__terms">
        {intl.formatMessage(messages.postbillGuestLoginAcknowledgements, {
          termsOfUse: (
            <a
              href={acknowledgements.links.termsOfUse}
              key="termsOfUse"
              target="_blank"
              rel="noreferrer"
            >
              {intl.formatMessage(messages.postbillGuestLoginTermsOfUse)}
            </a>
          ),
          privacyPolicy: (
            <a
              href={acknowledgements.links.privacyPolicy}
              key="privacyPolicy"
              target="_blank"
              rel="noreferrer"
            >
              {intl.formatMessage(messages.postbillGuestLoginPrivacyPolicy)}
            </a>
          ),
          privacyPractices: (
            <a
              href={acknowledgements.links.noticeOfPrivacyPractices}
              key="privacyPractices"
              target="_blank"
              rel="noreferrer"
            >
              {intl.formatMessage(messages.postbillGuestLoginPrivacyPractices)}
            </a>
          ),
        })}
      </p>
    </div>
  );
};

export default BillingFooter;
